import { render } from "./CreateProspectModal.vue?vue&type=template&id=e5b6800a&scoped=true"
import script from "./CreateProspectModal.vue?vue&type=script&lang=js"
export * from "./CreateProspectModal.vue?vue&type=script&lang=js"

import "./CreateProspectModal.vue?vue&type=style&index=0&id=e5b6800a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b6800a"]])

export default __exports__